import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { removeMarketFromPath } from '@bridebook/web/app-shared/lib/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const useAuthRedirect = () => {
  const router = useRouter();
  const market = useMarket();

  const redirect = useCallback(() => {
    const currentUrl = router.asPath;
    const urlWithoutMarket = removeMarketFromPath(currentUrl, market.prefix);
    const loginUrl = `${UrlHelper.login}&next=${encodeURIComponent(urlWithoutMarket)}`;
    router.push(loginUrl);
  }, [router, market]);

  return redirect;
};
